import React from 'react';
import { Table, Badge, Avatar } from '@/components/ui';
import type { AuditLog } from '../types/company.types';
import { getAuditAction } from '@/utils/status';
import { formatDateTime } from '@/utils/format';

interface AuditLogsDesktopTableProps {
  logs: AuditLog[];
  isLoading?: boolean;
}

export function AuditLogsDesktopTable({ logs, isLoading }: AuditLogsDesktopTableProps) {
  const columns = [
    {
      key: 'created_at',
      title: 'Thời gian',
      width: '180px',
      render: (val: string) => (
        <span className="text-slate-500 text-sm">
          {formatDateTime(val)}
        </span>
      )
    },
    {
      key: 'actor',
      title: 'Người thực hiện',
      render: (_: any, log: AuditLog) => (
        <div className="flex items-center gap-3">
          <Avatar
            src={log.actor_avatar}
            name={log.actor_name || 'Hệ thống'}
            size="xs"
          />
          <div className="flex flex-col">
            <span className="font-bold text-slate-900">{log.actor_name || 'Hệ thống'}</span>
            <span className="text-xs text-slate-500">{log.actor_email}</span>
          </div>
        </div>
      )
    },
    {
      key: 'action_code',
      title: 'Hành động',
      width: '140px',
      render: (val: string) => {
        const action = getAuditAction(val);
        return (
          <Badge variant={action.variant as any} className="text-xs font-bold ">
            <i className={`${action.icon} mr-1`} />
            {action.label}
          </Badge>
        );
      }
    },
    {
      key: 'summary',
      title: 'Nội dung',
      render: (val: string) => (
        <span className="text-slate-600 text-sm line-clamp-1" title={val}>{val}</span>
      )
    },
    {
      key: 'ip_address',
      title: 'Địa chỉ IP',
      width: '120px',
      className: 'text-xs text-slate-400 font-mono'
    }
  ];

  return (
    <Table
      columns={columns}
      data={logs}
      isLoading={isLoading}
      emptyTitle="Chưa có nhật ký hoạt động nào."
    />
  );
}
